import styled from 'styled-components';

export const ConnectionTool = styled.div`
float: right;
`